import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("table", () => {
    it("should render a component", async () => {
        const page = await newE2EPage();
        await page.setContent(`<uic-table></uic-table>`);
        const el = await page.find("uic-table");
        expect(el).toHaveClass("hydrated");
    });

    it("should match in empty state to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<uic-table></uic-table>`);
        const el = await page.find("uic-table");
        expect(el).toMatchSnapshot();
    });

    it("should render valid html", async () => {
        await testValidHtml(`<uic-table></uic-table>`);
    });
    describe("should sort data", () => {
        beforeEach(() => {
            // GIVEN
            expect(tableData.length).toEqual(5);
        });
        it("initially 'ascending' by 'latest_maintenance_iso' sort-field", async () => {
            // GIVEN
            const page = await newE2EPage();
            await page.setContent(uicTableDefinition);
            await page.waitForChanges();
            // WHEN
            const table = await page.find("uic-table");
            table.setProperty("initialSortingCriterion", {
                sortProperty: "latest_maintenance_iso",
                direction: "asc"
            });
            table.setProperty("data", tableData);
            await page.waitForChanges();

            // THEN
            const sortedRows = await page.findAll(".uic-table__tr");
            expect(sortedRows.length).toEqual(5);
            expect(sortedRows[0].innerHTML).toEqual(renderedTableRows[4]);
            expect(sortedRows[1].innerHTML).toEqual(renderedTableRows[1]);
            expect(sortedRows[2].innerHTML).toEqual(renderedTableRows[0]);
            expect(sortedRows[3].innerHTML).toEqual(renderedTableRows[2]);
            expect(sortedRows[4].innerHTML).toEqual(renderedTableRows[3]);

            const rowHeaders = await page.findAll(".uic-table-head-sort");
            expect(rowHeaders.length).toEqual(3);
            expect(rowHeaders[0].getAttribute("sorted-direction")).toEqual("");
            expect(rowHeaders[1].getAttribute("sorted-direction")).toEqual("");
            expect(rowHeaders[2].getAttribute("sorted-direction")).toEqual("asc");
        });

        it("initially 'descending' by 'name' field", async () => {
            // GIVEN
            const page = await newE2EPage();
            await page.setContent(uicTableDefinition);
            await page.waitForChanges();

            // WHEN
            const table = await page.find("uic-table");
            table.setProperty("initialSortingCriterion", {
                sortProperty: "name",
                direction: "desc"
            });
            table.setProperty("data", tableData);
            await page.waitForChanges();

            // THEN
            const sortedRows = await page.findAll(".uic-table__tr");
            expect(sortedRows.length).toEqual(5);
            expect(sortedRows[0].innerHTML).toEqual(renderedTableRows[2]);
            expect(sortedRows[1].innerHTML).toEqual(renderedTableRows[0]);
            expect(sortedRows[2].innerHTML).toEqual(renderedTableRows[3]);
            expect(sortedRows[3].innerHTML).toEqual(renderedTableRows[4]);
            expect(sortedRows[4].innerHTML).toEqual(renderedTableRows[1]);

            const rowHeaders = await page.findAll(".uic-table-head-sort");
            expect(rowHeaders.length).toEqual(3);
            expect(rowHeaders[0].getAttribute("sorted-direction")).toEqual("desc");
            expect(rowHeaders[1].getAttribute("sorted-direction")).toEqual("");
            expect(rowHeaders[2].getAttribute("sorted-direction")).toEqual("");
        });

        it("initially 'descending' by 'serial_number' field", async () => {
            // GIVEN
            const page = await newE2EPage();
            await page.setContent(uicTableDefinition);
            await page.waitForChanges();

            // WHEN
            const table = await page.find("uic-table");
            table.setProperty("initialSortingCriterion", {
                sortProperty: "serial_number",
                direction: "desc"
            });
            table.setProperty("data", tableData);
            await page.waitForChanges();
            // THEN
            const sortedRows = await page.findAll(".uic-table__tr");
            expect(sortedRows.length).toEqual(5);
            expect(sortedRows[0].innerHTML).toEqual(renderedTableRows[1]);
            expect(sortedRows[1].innerHTML).toEqual(renderedTableRows[3]);
            expect(sortedRows[2].innerHTML).toEqual(renderedTableRows[4]);
            const noDataCell1 = await sortedRows[0].find(".uic-table__cell-container--no-data");
            expect(noDataCell1).not.toBeNull();
            const noDataCell2 = await sortedRows[1].find(".uic-table__cell-container--no-data");
            expect(noDataCell2).not.toBeNull();

            const rowHeaders = await page.findAll(".uic-table-head-sort");
            expect(rowHeaders.length).toEqual(3);
            expect(rowHeaders[0].getAttribute("sorted-direction")).toEqual("");
            expect(rowHeaders[1].getAttribute("sorted-direction")).toEqual("desc");
            expect(rowHeaders[2].getAttribute("sorted-direction")).toEqual("");
        });

        it("initially by data set order when no initial sort criterion specified", async () => {
            // GIVEN
            const page = await newE2EPage();
            await page.setContent(uicTableDefinition);
            await page.waitForChanges();

            // WHEN
            const table = await page.find("uic-table");
            table.setProperty("data", tableData);
            await page.waitForChanges();

            // THEN
            const sortedRows = await page.findAll(".uic-table__tr");
            expect(sortedRows.length).toEqual(5);
            expect(sortedRows[0].innerHTML).toEqual(renderedTableRows[0]);
            expect(sortedRows[1].innerHTML).toEqual(renderedTableRows[1]);
            expect(sortedRows[2].innerHTML).toEqual(renderedTableRows[2]);
            expect(sortedRows[3].innerHTML).toEqual(renderedTableRows[3]);
            expect(sortedRows[4].innerHTML).toEqual(renderedTableRows[4]);

            const rowHeaders = await page.findAll(".uic-table-head-sort");
            expect(rowHeaders.length).toEqual(3);
            expect(rowHeaders[0].getAttribute("sorted-direction")).toEqual("");
            expect(rowHeaders[1].getAttribute("sorted-direction")).toEqual("");
            expect(rowHeaders[2].getAttribute("sorted-direction")).toEqual("");
        });

        it("sort and update data correctly with and without initial sort criterion", async () => {
            const page = await newE2EPage();
            await page.setContent(uicTableDefinition);
            await page.waitForChanges();

            // Without initialSortingCriterion
            const table = await page.find("uic-table");
            table.setProperty("data", [tableData[4], tableData[3], tableData[2]]);
            await page.waitForChanges();

            let sortedRows = await page.findAll(".uic-table__tr");
            expect(sortedRows.length).toEqual(3);
            expect(sortedRows[0].innerHTML).toEqual(renderedTableRows[4]);
            expect(sortedRows[1].innerHTML).toEqual(renderedTableRows[3]);
            expect(sortedRows[2].innerHTML).toEqual(renderedTableRows[2]);

            table.setProperty("data", tableData);
            await page.waitForChanges();

            sortedRows = await page.findAll(".uic-table__tr");
            expect(sortedRows.length).toEqual(5);
            expect(sortedRows[0].innerHTML).toEqual(renderedTableRows[0]);
            expect(sortedRows[1].innerHTML).toEqual(renderedTableRows[1]);
            expect(sortedRows[2].innerHTML).toEqual(renderedTableRows[2]);
            expect(sortedRows[3].innerHTML).toEqual(renderedTableRows[3]);
            expect(sortedRows[4].innerHTML).toEqual(renderedTableRows[4]);

            // With initialSortingCriterion
            table.setProperty("initialSortingCriterion", {
                sortProperty: "serial_number",
                direction: "desc"
            });
            table.setProperty("data", [tableData[0], tableData[2], tableData[4]]);
            await page.waitForChanges();

            sortedRows = await page.findAll(".uic-table__tr");
            expect(sortedRows.length).toEqual(3);
            expect(sortedRows[0].innerHTML).toEqual(renderedTableRows[4]);
            expect(sortedRows[1].innerHTML).toEqual(renderedTableRows[0]);
            expect(sortedRows[2].innerHTML).toEqual(renderedTableRows[2]);
        });
    });
});

const uicTableDefinition = `
     <uic-table
                self-sorting
                data-test-id="1"
            >
                <uic-table-column
                    field="name"
                    label="Name"
                    sortable
                ></uic-table-column>
                <uic-table-column
                    field="serial_number"
                    label="Serial number"
                    sortable
                    group
                ></uic-table-column>
                <uic-table-column
                    field="latest_maintenance_localized"
                    label="Latest Maintenance"
                    sortable
                    sort-field="latest_maintenance_iso"
                ></uic-table-column>
            </uic-table>
`;
const tableData = [
    {
        name: "TruMark",
        serial_number: "444-4444",
        id: "ZU3",
        latest_maintenance_localized: "January 1, 2020",
        latest_maintenance_iso: "2020-01-01T00:00:00Z"
    },
    {
        name: "TruLaser",
        id: "ZE7",
        latest_maintenance_localized: "January 15, 2019",
        latest_maintenance_iso: "2019-01-15T00:00:00Z"
    },
    {
        name: "TruMark+",
        serial_number: "222-2222",
        id: "CT7",
        latest_maintenance_localized: "May 17, 2020",
        latest_maintenance_iso: "2020-05-17T00:00:00Z"
    },
    {
        name: "TruLaser+",
        id: "BT4",
        latest_maintenance_localized: "August 11, 2020",
        latest_maintenance_iso: "2020-08-11T00:00:00Z"
    },
    {
        name: "TruLaser-v4",
        serial_number: "555-5555",
        id: "WS3",
        latest_maintenance_localized: "April 5, 2018",
        latest_maintenance_iso: "2018-04-05T00:00:00Z"
    }
];

const renderedTableRows = [
    // eslint-disable-next-line
    '<td class="uic-table__td" data-testid="uic-table__td-name"><div class="uic-table__cell-container"><span>TruMark</span></div></td><td class="uic-table__td" data-testid="uic-table__td-serial_number"><div class="uic-table__cell-container uic-table__cell-container--group"><span>444-4444</span></div></td><td class="uic-table__td" data-testid="uic-table__td-latest_maintenance_localized"><div class="uic-table__cell-container"><span>January 1, 2020</span></div></td>',
    // eslint-disable-next-line
    '<td class="uic-table__td" data-testid="uic-table__td-name"><div class="uic-table__cell-container"><span>TruLaser</span></div></td><td class="uic-table__td" data-testid="uic-table__td-serial_number"><div class="uic-table__cell-container uic-table__cell-container--no-data uic-table__cell-container--group"><span></span></div></td><td class="uic-table__td" data-testid="uic-table__td-latest_maintenance_localized"><div class="uic-table__cell-container"><span>January 15, 2019</span></div></td>',
    // eslint-disable-next-line
    '<td class="uic-table__td" data-testid="uic-table__td-name"><div class="uic-table__cell-container"><span>TruMark+</span></div></td><td class="uic-table__td" data-testid="uic-table__td-serial_number"><div class="uic-table__cell-container uic-table__cell-container--group"><span>222-2222</span></div></td><td class="uic-table__td" data-testid="uic-table__td-latest_maintenance_localized"><div class="uic-table__cell-container"><span>May 17, 2020</span></div></td>',
    // eslint-disable-next-line
    '<td class="uic-table__td" data-testid="uic-table__td-name"><div class="uic-table__cell-container"><span>TruLaser+</span></div></td><td class="uic-table__td" data-testid="uic-table__td-serial_number"><div class="uic-table__cell-container uic-table__cell-container--no-data uic-table__cell-container--group"><span></span></div></td><td class="uic-table__td" data-testid="uic-table__td-latest_maintenance_localized"><div class="uic-table__cell-container"><span>August 11, 2020</span></div></td>',
    // eslint-disable-next-line
    '<td class="uic-table__td" data-testid="uic-table__td-name"><div class="uic-table__cell-container"><span>TruLaser-v4</span></div></td><td class="uic-table__td" data-testid="uic-table__td-serial_number"><div class="uic-table__cell-container uic-table__cell-container--group"><span>555-5555</span></div></td><td class="uic-table__td" data-testid="uic-table__td-latest_maintenance_localized"><div class="uic-table__cell-container"><span>April 5, 2018</span></div></td>'
];
